import React, { useState, useEffect, Suspense } from 'react';
import Cookies from 'js-cookie';
import { BrowserRouter,Routes, Route, Navigate,useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { appAbsPath, userToken, executeLaravelAPI, loadGTMWithTimeout, loadClarityWithTimeout, applyGlobalHeaderMargin, getCookie, executeLaravelFrontAPI } from './Components/Admin/Utils';
import { SearchVisibilityProvider } from './Components/Front/Layouts/SearchVisibilityContext';
import { CompareProjectProvider } from './Components/Front/Layouts/CompareProjectContext';
import { setUserId, updateAllCookiesData } from './Components/Admin/UserActivatyTracker';
//React GA
import { InitializeGoogleAnalytics } from './Components/Admin/GoogleAnalytics';
//Front Layout
import FrontHeader from './Components/Front/Layouts/Header';
import FrontProjectsList from './Components/Front/Pages/ProjectList';

// import FrontBlogsList from './Components/Front/Pages/Blogs/BlogsList';
// import FrontBlogDetails from './Components/Front/Pages/Blogs/BlogDetails';

// import FrontMapProjectsList from './Components/Front/Pages/MapViewProjectList';
// import NewFrontMapProjectsList from './Components/Front/Pages/NewMapViewProjectList';
// import NewMapView from './Components/Front/Pages/NewMapView';
// import NewMaps from './Components/Front/Pages/NewMaps';
import ProjectDetails from './Components/Front/Pages/ProjectDetails';
import Home from './Components/Front/Home';
import UserActivity from './Components/Front/Pages/UserActivity';
import WishListDetails from './Components/Front/Pages/WishListDetails';
import ComparisonLayout from './Components/Front/Pages/ComparisonLayout';
import LocationPage from './Components/Front/Pages/Location/Localitydetails';
import Page404 from './Components/Front/Pages/Page404';
import PunePage from './Components/Front/Pages/Pune/PuneLocalities';
import ComparePage from './Components/Front/Pages/Compare/Compare';
import MyActivity from './Components/Front/Pages/MyActivity';
import BlogDetail from './Components/Front/Pages/BlogDetail';
import BlogsListing from './Components/Front/Pages/BlogsListing';
import BlogCatogeryListing from './Components/Front/Pages/Blogs/BlogCatogeryListing';
import IRFS from './Components/Front/Pages/IRFS/IRFS';
import PDP from './Components/Front/Pages/IRFS/PDP';
// import RealEstateMarketing from './Components/Front/Pages/SalesMarketing/RealEstateMarketing';
// import RealEstateSales from './Components/Front/Pages/SalesMarketing/RealEstateSales';
import BwStudio from './Components/Front/Pages/BwStudio/BwStudio';
import WebStory from './Components/Front/Pages/WebStories';
import StoryViewer from './Components/Front/Pages/StoryViewer';

//Admin Layout
import Header from './Components/Admin/Layouts/Header';
import Sidebar from './Components/Admin/Layouts/Sidebar';
import Footer from './Components/Admin/Layouts/Footer';
// import UTMTracker from './Components/Front/UTMTracker';

// Admin Custom Components
import Login from './Components/Admin/Auth/Login';
import Dashboard from './Components/Admin/Pages/Dashboard';
import ProjectsList from './Components/Admin/Pages/Project/ProjectsList';
import VerifiedProjectList from './Components/Admin/Pages/Project/VerifiedProjectList';
import UpdatedProjectList from './Components/Admin/Pages/Project/UpdatedProjectList';
import ProjectForm from './Components/Admin/Pages/ProjectForm';
import Leads from './Components/Admin/Pages/Project/Leads';
import DeveloperAddNewForm from './Components/Admin/Pages/Developer/DeveloperAddNew';
import DeveloperEditForm from './Components/Admin/Pages/Developer/DeveloperEdit';
import OfferAddNewForm from './Components/Admin/Pages/Offer/OfferAddNew';
import CouponList from './Components/Admin/Pages/Offer/CouponList';
import LocationAddNewForm from './Components/Admin/Pages/Location/LocationAddNew';
import LocationEditForm from './Components/Admin/Pages/Location/LocationEdit';
import DisabledProjectList from './Components/Admin/Pages/Project/DisabledProjectList';
import UserActivityData from './Components/Front/Pages/UserActivityData';

import LocationsList from './Components/Admin/Pages/Location/LocationsList';
import DevelopersList from './Components/Admin/Pages/Developer/DevelopersList';
import ShortUpdatesList from './Components/Admin/Pages/ShortUpdates/ShortUpdatesList';
import ShortUpdateAddNew from './Components/Admin/Pages/ShortUpdates/ShortUpdateAddNew';
import ShortUpdateEdit from './Components/Admin/Pages/ShortUpdates/ShortUdateEdit';
import CreateJUser from './Components/Front/Pages/CreateJUser';
import CreateJUserSelldo from './Components/Front/Pages/CreateJuserSelldo';

import OffersList from './Components/Admin/Pages/Offer/OffersList';
import OfferEditForm from './Components/Admin/Pages/Offer/OfferEdit';

import UsersList from './Components/Admin/Auth/UsersList';
import UserEditForm from './Components/Admin/Auth/UserEdit';

import './App.scss';
import UserCouponListing from './Components/Front/Pages/Profile/UserCouponListing';

import TruliaMap from './Components/Front/Pages/TruliaMap';

const FrontFooter = React.lazy(() => import('./Components/Front/Layouts/Footer'));
// const TRACKING_ID = "G-B84KD79XTF"; // your Measurement ID
const App = () => {
    const location = useLocation();
    const [isAdminLoggedIn, setAdminLoggedIn] = useState(false);
    const [isUserLoggedIn, setUserLoggedIn] = useState(false);
    const [loggedUserData, setUserData] = useState({});
    const [page404, set404Page] = useState(0);
    const [loading] = useState(false);
    const [progress] = useState(0);
    const [isUserCameFromActivity, setIsUserCameFromActivity] = useState(null);

    useEffect(() => {
        // Read the cookie value and update the state

        const handleClick = (event) => {
            const tag = event.target.tagName.toLowerCase();
            if (tag === 'button' || tag === 'a') {
                set404Page(0);
            }
        }

        const cookieValue = getCookie('activityLogin');
        setIsUserCameFromActivity(cookieValue);
        
        const currentPath = location.pathname;
        const pathParts = currentPath.split('/').filter(Boolean); // Filter out empty strings
        const pathPartsLength = pathParts.length;
        const citiesListArray=process.env.REACT_APP_APPROVED_CITIES.split(',');
        const citiesList = citiesListArray.map(city => city.trim());
               
        if (pathPartsLength > 1) {
            const firstWordArray = ['properties','property','project','location','blog','blogs','portaladmin','web-story'];
            const secondWordArray = ['login','profile','buy','property-in-pune','property-in-mumbai','map-view','mapview','map','what-a-view-in-pune','new-projects-in-pune','affordable-homes-in-pune','properties-for-sale-in-pune','comparison'];
            const updatedSecondWordArray = [...secondWordArray, ...citiesList];
            setTimeout(async () => {
                if (!firstWordArray.includes(pathParts[0]) && !pathParts[0].includes('-bhk-') && !pathParts[0].includes('-in-')) {
                    //alert('1st wala');
                    await fetch(currentPath);
                    set404Page(1);
                } 
               
                if (!firstWordArray.includes(pathParts[0]) && !updatedSecondWordArray.includes(pathParts[1]) && !pathParts[0].includes('-bhk-') && !pathParts[0].includes('-in-')) {
                    //alert('2nd wala');
                    await fetch(currentPath);
                    set404Page(1);
                }
                
                if (pathParts[0] === 'location' && citiesList.includes(pathParts[1])) {
                    const locationdetails={
                        "locationslug": pathParts[2],
                        "city": pathParts[1]
                    };
                    const checklocation=await executeLaravelFrontAPI('locationbyslugwithcity', locationdetails, 'GET');
                    if (checklocation.data === null || checklocation.data === undefined || checklocation.data === '') {
                        //alert('location wala');
                        await fetch(currentPath);
                        set404Page(1);
                    }
                }

                if (pathParts[0] === 'blog') {
                    const apiUrl = `https://corporate.beyondwalls.com/?portalblogsdetails=1&portalblogid=${pathParts[1]}`;
                    const response = await fetch(apiUrl);
                    if (response.status === 200) {
                        const data = await response.json();
                        if (!data) {
                            //alert('blog wala');
                            await fetch(currentPath);
                            set404Page(1);
                        }
                    }
                }
                if (pathParts[1] === 'buy' && !citiesList.includes(pathParts[2])) {
                    //alert('buy wala');
                    await fetch(currentPath);
                    set404Page(1);
                }

                if (pathParts[0] === 'property' && citiesList.includes(pathParts[1])) {
                    const checkproject = await executeLaravelFrontAPI(`project/${pathParts[3]}`, '', 'GET');
                    if (checkproject.data === 'Project Not Found') {
                        //alert('Project wala');
                        await fetch(currentPath);
                        set404Page(1);
                    }
                }
                
            }, 100);
        }
        
        if (pathPartsLength === 1) {
            const firstWordArray = ['pune','profile','compare','bwstudio','myactivity','blogs','useractivitydata','properties','usercreate','usercreateselldo','web-stories'];
            const propertiesBrandPagesArray = ['affordable-apartments-in-pune','ready-to-move-flats-in-pune','great-view-projects-in-pune','what-a-view-in-pune','new-projects-in-pune','hot-selling-projects-in-pune','high-rise-projects-in-pune','properties-for-sale-in-pune','live-in-sky-in-pune'];
            const locationPropertiesBrandPagesArray = ['affordable-apartments-in-','ready-to-move-flats-in-','great-view-projects-in-','what-a-view-in-','new-projects-in-','hot-selling-projects-in-','high-rise-projects-in-','properties-for-sale-in-','live-in-sky-in-'];
            
            setTimeout(async () => {
                if (pathParts[0].includes('-bhk-') && pathParts[0].includes('-in-')) {
                    const bedroom = pathParts[0].split('-bhk-')[0];
                    const locality_city = pathParts[0].split('-bhk-')[1].split('-in-')[1];
                    
                    const locality_city_parts = locality_city.split('-').filter(Boolean); // Filter out empty strings
                    const city = locality_city_parts.length;
                    if (locality_city_parts.length > 1) { // For City Check
                        if (locality_city_parts.length > 2) {
                            var localityName = locality_city_parts.slice(0, city - 1).join('-');
                            var cityName = locality_city_parts[city - 1];
                        } else {
                            var cityName = locality_city_parts[city - 1];
                            var localityName = locality_city_parts[city - 2];
                        }
                        if (!citiesList.includes(cityName)) {   
                            await fetch(currentPath);
                            set404Page(1);
                        }
                        if(localityName) {
                            const locationdetails={
                                "locationslug": localityName.toLowerCase(),
                                "city": cityName
                            };
                            const checklocation=await executeLaravelFrontAPI('locationbyslugwithcity', locationdetails, 'GET');
                            if (checklocation.data === null || checklocation.data === undefined || checklocation.data === '') {
                                await fetch(currentPath);
                                set404Page(1);
                            }
                        }
                    } 
                    if (locality_city_parts.length === 1){
                        await fetch(currentPath);
                        set404Page(1);
                    }
                    if(isNaN(bedroom) || pathParts[0].split('-bhk-')[1].split('-in-')[0] !== 'flats-for-sale'){
                        await fetch(currentPath);
                        set404Page(1);
                    }
                }
                var flag=0;
                if (locationPropertiesBrandPagesArray.some(str => pathParts[0].includes(str))) {
                    const city = pathParts[0].split('-in-')[1];
                    const locality_city_parts = city.split('-').filter(Boolean); // Filter out empty strings
                    const cityNameLength = locality_city_parts.length;
                    if (locality_city_parts.length > 2) {
                        var localityName = locality_city_parts.slice(0, cityNameLength - 1).join('-');
                        var cityName = locality_city_parts[cityNameLength - 1];
                    } else {
                        var cityName = locality_city_parts[cityNameLength - 1];
                        var localityName = locality_city_parts[cityNameLength - 2];
                    }

                    if (!citiesList.includes(cityName)) {
                        //alert('bhk walafds ');
                        //await fetch(currentPath);
                        //set404Page(1);
                    }
                    if(localityName) {
                        // flag=1;
                        // const locationdetails={
                        //     "locationslug": localityName.toLowerCase(),
                        //     "city": cityName
                        // };
                        // const checklocation=await executeLaravelFrontAPI('locationbyslugwithcity', locationdetails, 'GET');
                        // if (checklocation.data === null || checklocation.data === undefined || checklocation.data === '') {
                        //     await fetch(currentPath);
                        //     set404Page(1);
                        // }
                    }
                    
                }

                if (flag===0 && !propertiesBrandPagesArray.includes(pathParts[0]) && !firstWordArray.includes(pathParts[0]) && (!pathParts[0].includes('-bhk-') || !pathParts[0].includes('-in-'))) {
                    //alert('Single wala');
                    await fetch(currentPath);
                    set404Page(1);
                } 
            }, 100);
        }
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
          };
    }, [location.pathname]); // Runs once after the component mounts
    useEffect(() => {
        setUserId()
        // ReactGA.initialize(TRACKING_ID);
        // Send pageview with a custom path
        // ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: window.location.pathname });
    }, [])
    useEffect(() => {
        const GTM_TRACKING_ID = process.env.REACT_APP_GTM_TRACKING_ID;
        // loadClarityWithTimeout(5000);
        loadGTMWithTimeout(GTM_TRACKING_ID, false, 100);
        InitializeGoogleAnalytics();
    }, []);

    useEffect(() => {
        if (isUserCameFromActivity === null) return; // Wait until state is set
        //progressBar(setLoading, setProgress);
        if (userToken !== null) {
            const checkAuthentication = async () => {
                try {
                    // Make a request to your Laravel backend to check if the user is authenticated
                    const userdata = await executeLaravelAPI('check-auth', '', 'GET', userToken);
                    if (userdata.status === 200) {
                        setUserData(userdata.user)
                        Cookies.set('userData', JSON.stringify(userdata.user), { expires: 2 });
                        updateAllCookiesData();
                        if ((userdata.user.userrole === 'superadmin' || userdata.user.userrole === 'admin') && (isUserCameFromActivity !='true')) {
                            setAdminLoggedIn(true);
                        } else {
                            setUserData(userdata.user);
                            setUserLoggedIn(true);
                        }
                    } else {
                        localStorage.removeItem('bwToken'); localStorage.clear();
                        setAdminLoggedIn(false);
                        setUserLoggedIn(false);
                    }
                } catch (error) {
                    console.error('Error checking authentication:', error);
                }
            };
            checkAuthentication();
        } else {
            setAdminLoggedIn(false);
            setUserLoggedIn(false);
        }
    }, [isUserCameFromActivity]);

    const handleLogin = (userdetails) => {
        localStorage.setItem('bwToken', userdetails.access_token);
        //setCookie('bwToken', userdetails.access_token);
        Cookies.set('userData', JSON.stringify(userdetails.user), { expires: 2 });
        setUserData(userdetails.user);
        if ((userdetails.user.userrole === 'superadmin' || userdetails.user.userrole === 'admin') && (isUserCameFromActivity !='true')) {
            setAdminLoggedIn(true);
        } else {
            setUserLoggedIn(true);
        }
    };

    useEffect(() => {
        const handleMarginAdjustment = () => {
            applyGlobalHeaderMargin(".header", "dynamicHeaderMargin");
        };
        if (document.readyState === "complete") {
            handleMarginAdjustment();
        } else {
            window.addEventListener("load", handleMarginAdjustment);
        }
        window.addEventListener("resize", handleMarginAdjustment);

        return () => {
            window.removeEventListener("load", handleMarginAdjustment);
            window.removeEventListener("resize", handleMarginAdjustment);
        };
    }, []);

    const showHeaderAndFooter = () => {
        const path = window.location.pathname;
        // Updated regex to match /useractivitydata with or without numbers
        const userActivityRegex = /^\/useractivitydata(\/\d+)?$/;
        const isStoryViewerRoute = /^\/web-story\/[\w-]+$/;
    
        if (userActivityRegex.test(path) || isStoryViewerRoute.test(path)) {
            return false;
        }
        return true;
    };

    return (
        <div>
            <ToastContainer />
            {/* <UTMTracker /> */}
            {isAdminLoggedIn ?
                (
                    <>
                        {loading ? (
                            <div>
                                <progress value={progress} max="100" style={{ width: '100%' }} />
                            </div>
                        ) : (
                            <>
                                <div className="container-scroller">
                                    {showHeaderAndFooter() && (
                                        <SearchVisibilityProvider>
                                            <Header loggeduserdetails={loggedUserData} />
                                        </SearchVisibilityProvider>
                                    )}
                                    <div className="container-fluid page-body-wrapper">
                                        <Sidebar />
                                        <div className="main-panel">
                                            <div className="content-wrapper">
                                                <Routes>
                                                    {/* <Route exact path={`${appAbsPath}`} element={<Home />} />    */}
                                                    {/* <Route exact path="*" element={<Navigate to={`${appAbsPath}/portaladmin/dashboard`} />} /> */}
                                                    <Route exact path={`${appAbsPath}/portaladmin/dashboard`} element={<Dashboard />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/projects`} element={<ProjectsList />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/add/project`} element={<ProjectForm />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/add/developer`} element={<DeveloperAddNewForm />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/developers`} element={<DevelopersList />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/developer/edit/:id`} element={<DeveloperEditForm />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/add/offer`} element={<OfferAddNewForm />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/couponlist`} element={<CouponList />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/add/location`} element={<LocationAddNewForm />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/locations`} element={<LocationsList />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/offers`} element={<OffersList />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/users`} element={<UsersList />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/user/edit/:id`} element={<UserEditForm />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/offer/edit/:id`} element={<OfferEditForm />} />

                                                    <Route exact path={`${appAbsPath}/portaladmin/location/edit/:id`} element={<LocationEditForm />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/verifiedprojects`} element={<VerifiedProjectList />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/updatedprojects`} element={<UpdatedProjectList />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/disabledprojects`} element={<DisabledProjectList />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/leads`} element={<Leads />} />

                                                    <Route exact path={`${appAbsPath}/portaladmin/shortupdates`} element={<ShortUpdatesList />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/add-short-update`} element={<ShortUpdateAddNew />} />
                                                    <Route exact path={`${appAbsPath}/portaladmin/shortupdates/edit/:id`} element={<ShortUpdateEdit />} />
                                                </Routes>
                                            </div>
                                            <Footer />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    // isUserLoggedIn ? (
                    <>
                        {/* <BrowserRouter> */}
                            <SearchVisibilityProvider>
                                {showHeaderAndFooter() && (
                                    <Suspense fallback={<div>Loading...</div>}>
                                        <FrontHeader loggeduserdetails={loggedUserData} onLogin={handleLogin} />
                                    </Suspense>
                                )}


                                <CompareProjectProvider>
                                    <Routes>
                                        {isUserLoggedIn && (
                                            <>
                                                <Route exact path={`${appAbsPath}/profile`} element={<UserActivity onLogin={handleLogin} />} />

                                                {loggedUserData.userrole === 'developer' && (

                                                    <Route exact path={`${appAbsPath}/profile/user-coupons`} element={<UserCouponListing onLogin={handleLogin} />} />
                                                )};
                                                {loggedUserData.userrole === 'user' && (
                                                    <Route exact path={`${appAbsPath}/profile/my-coupons`} element={<UserCouponListing onLogin={handleLogin} />} />
                                                )}
                                            </>
                                        ) }
s
                                        {page404 === 1 ? (
                                            <Route
                                            path="*"
                                            element={<Page404 onLogin={handleLogin} />}
                                            />
                                        ) : (
                                            <>
                                        <Route exact path={`${appAbsPath}`} element={<Home loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/useractivitydata`} element={<UserActivityData loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />

                                        <Route exact path={`${appAbsPath}/user/wishlist`} element={<WishListDetails loggeduserdetails={loggedUserData} />} />
                                        <Route exact path={`${appAbsPath}/properties`} element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                        {/* <Route exact path={`${appAbsPath}/projects/map-view`} element={<NewMapView loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/irfs/projects/map-view`} element={<NewMapView loggeduserdetails={loggedUserData} onLogin={handleLogin} />} /> */}
                                        <Route exact path={`${appAbsPath}/property/:projectslug`} element={<ProjectDetails loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/project/:projectslug`} element={<ProjectDetails loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/property/:city/:location/:projectslug`} element={<ProjectDetails loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/irfs/property/:projectslug`} element={<ProjectDetails loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/pdp/:projectslug`} element={<PDP loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/portaladmin/login`} element={<Login onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/portaladmin`} element={<Navigate to={`${appAbsPath}/portaladmin/login`} />} />
                                        <Route exact path={`${appAbsPath}/property/comparison`} element={<ComparisonLayout onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/location`} element={<LocationPage onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/location/:slug`} element={<LocationPage onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/location/:city/:slug`} element={<LocationPage onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/pune`} element={<PunePage onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/compare`} element={<ComparePage onLogin={handleLogin} loggeduserdetails={loggedUserData}/>} />
                                        <Route exact path={`${appAbsPath}/bwstudio`} element={<BwStudio onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/irfs`} element={<IRFS onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/irfs/projects`} element={<FrontProjectsList onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/myactivity`} element={<MyActivity onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/blogdetail`} element={<BlogDetail onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/blogslisting`} element={<Navigate to={`${appAbsPath}/blogs`} />} />
                                        <Route exact path={`${appAbsPath}/blogs`} element={<BlogsListing loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/blog`} element={<Navigate to={`${appAbsPath}/blogs`} />} />
                                        <Route exact path={`${appAbsPath}/blog/:slug`} element={<BlogDetail loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/blogs/:catogery`} element={<BlogCatogeryListing loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                      
                                        <Route exact path={`${appAbsPath}/properties/buy/:city/map-view`} element={<TruliaMap loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                        <Route exact path={`${appAbsPath}/irfs/properties/buy/:city/map-view`} element={<TruliaMap loggeduserdetails={loggedUserData} onLogin={handleLogin} />} /> 
                                        {/* <Route exact path={`${appAbsPath}/real-estate-marketing`} element={<RealEstateMarketing loggeduserdetails={loggedUserData} onLogin={handleLogin} />} /> */}
                                        {/* <Route exact path={`${appAbsPath}/real-estate-sales`} element={<RealEstateSales loggeduserdetails={loggedUserData} onLogin={handleLogin} />} /> */}


                                        {/* <Route exact
                                            path={`${appAbsPath}/:bedroom([0-9]+)-bhk-flats-for-sale-in-:locality([a-zA-Z0-9-]+)-:city([a-zA-Z0-9-]+)`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        /> */}
                                        
                                        <Route exact
                                            path={`${appAbsPath}/:bedroom-bhk-flats-for-sale-in-locality-city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />  
                                        <Route exact
                                            path={`${appAbsPath}/:bedroom-bhk-flats-for-sale-in-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />
                                        <Route exact
                                            path={`${appAbsPath}/property-in-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />

                                        <Route exact
                                            path={`${appAbsPath}/ready-to-move-flats-in-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />
                                        <Route exact
                                            path={`${appAbsPath}/ready-to-move-flats-in-:locality-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />

                                        <Route exact
                                            path={`${appAbsPath}/high-rise-projects-in-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />
                                        <Route exact
                                            path={`${appAbsPath}/high-rise-projects-in-:locality-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />

                                        <Route exact
                                            path={`${appAbsPath}/great-view-projects-in-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />
                                        <Route exact
                                            path={`${appAbsPath}/great-view-projects-in-:locality-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />

                                        <Route exact
                                            path={`${appAbsPath}/what-a-view-in-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />
                                        <Route exact
                                            path={`${appAbsPath}/what-a-view-in-:locality-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />

                                        <Route exact
                                            path={`${appAbsPath}/new-projects-in-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />
                                        <Route exact
                                            path={`${appAbsPath}/new-projects-in-:locality-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />

                                        <Route exact
                                            path={`${appAbsPath}/hot-selling-projects-in-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />
                                        <Route exact
                                            path={`${appAbsPath}/hot-selling-projects-in-:locality-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />

                                        <Route exact
                                            path={`${appAbsPath}/affordable-apartments-in-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />

                                        <Route exact
                                            path={`${appAbsPath}/affordable-homes-in-:locality-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />

                                        <Route exact
                                            path={`${appAbsPath}/live-in-sky-in-:locality-:city`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />
                                        <Route
                                            path={`${appAbsPath}/properties/buy/:urlcity/`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />
                                        <Route
                                            path={`${appAbsPath}/properties/buy/:urlcity/:urllocality`}
                                            element={<FrontProjectsList loggeduserdetails={loggedUserData} onLogin={handleLogin} />}
                                        />
                                        
                                        <Route exact path={`${appAbsPath}/usercreate`} element={<CreateJUser loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />

                                        <Route exact path={`${appAbsPath}/usercreateselldo`} element={<CreateJUserSelldo loggeduserdetails={loggedUserData} onLogin={handleLogin} />} />
                                        
                                        <Route exact path={`${appAbsPath}/web-stories`} element={<WebStory/>} />
                                        <Route exact path={`${appAbsPath}/web-story/:slug`} element={<StoryViewer/>} />
                                        {/* <Route exact path={`${appAbsPath}/404`} element={<Page404 onLogin={handleLogin} />} />
                                        <Route exact path="*" element={<Page404 onLogin={handleLogin} />} /> */}
                                        </>
                                        )}

                                    </Routes>  
                                    {showHeaderAndFooter() && (
                                        <FrontFooter />
                                    )}

                                </CompareProjectProvider>
                            </SearchVisibilityProvider>
                        {/* </BrowserRouter> */}
                    </>
                )
            }
        </div>
    );
};
export default App;
